module.exports = __webpack_public_path__ + "static/9-61cd34e7fa5974989fbdc2afba367248.png";